<template>
    <form @submit.prevent="handleSendReminder">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Send Reminder</p>
            </header>
            <section class="modal-card-body">
                <o-field label="Pick a Custom Date" :type="fieldType('remind_at')" :message="getError('remind_at')">
                    <flat-pickr
                        v-model="reminder.remind_at"
                        :config="{ enableTime: true }"
                        class="input"
                        placeholder="Pick a Date">
                    </flat-pickr>
                </o-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import HandlesForm from '../../mixins/HandlesForm'

    export default {
        mixins: [HandlesForm],

        props: {
            projectId: {
                required: true,
                type: Number
            },
            contactId: {
                required: true,
                type: Number
            }
        },

        data () {
            return {
                reminder: {
                    remind_at: '',
                    project_id: this.projectId,
                    contact_id: this.contactId
                }
            }
        },

        methods: {
            ...mapActions({
                remind: 'remind'
            }),

            handleSendReminder () {
                let submit = this.wrapSubmit(this.remind)
                submit(this.reminder)
                    .then(res => {
                        this.successMessage('Reminder successfull sent')
                        this.$parent.$parent.$emit('update:active', false)
                        return res
                    })
            }
        }
    }
</script>
